import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { observer } from "mobx-react-lite";
import GuiasRastreo from "./GuiasRastreo";
import ActualizacionesTracker from "../components/ActualizacionesTracker";
import InfoGeneralEnvios from "../../components/usuarios/InfoGeneralEnvios";
import { RootStoreContext } from "../../app/store/root";
import { ErrorMessages } from "../../app/util/messages";
import { useParams,useNavigate } from "react-router-dom";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

import LogisticBackdrop from "../LogisticBackdrop";

const initialState = {
  noGuium: undefined,
};

const RastreoEnvio = () => {
  const navigate = useNavigate();
  const rootStore = useContext(RootStoreContext);
  const { entity, getGuide } = rootStore.shipmentStore;
  const { noGuia } = useParams();
  /* UseState */
  const [validGuide, setValidGuide] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [model, setModel] = useState(initialState);
  const [errors, setErrors] = useState({
    noGuium: false,
  });
  const [messages, setMessages] = useState({
    noGuium: undefined,
  });
  /* End UseState */

  useEffect(() => {
    document.title = "Lilofy | Rastreo";
    if (!errors.noGuium && model?.noGuium) setDisabled(false);
    else setDisabled(true);
  }, [errors]);

  useEffect(() => {
    
    console.log(noGuia);
    if (noGuia) {
      // Si hay un parámetro 'noGuia' en la URL, realiza la búsqueda por defecto
      setValue("noGuium", noGuia);
      getGuide(noGuia).then(
        (response) => {
          if (response) setValidGuide(response);
        },
        (err) => {
          setError("noGuium", true);
          setMessage("noGuium", ErrorMessages.envio.GuiumNotFound);
        }
      );
    }
  }, []); // El segundo parámetro del useEffect es un array de dependencias, en este caso, vacío

  /* Methods */
  const setValue = (key, value) => {
    setModel({ ...model, ...{ [key]: value } });
  };
  const setError = (key, value) => {
    setErrors({ ...errors, ...{ [key]: value } });
  };
  const setMessage = (key, value) => {
    setMessages({ ...messages, ...{ [key]: value } });
  };
  /* End Methods */
  return (
      <div className='container-rastreo'>
          <LogisticBackdrop />
      <div className='mb-2 d-flex' style={{ alignItems: 'center', marginTop: '2%' }}>
          <Typography color='primary' variant='h4'>
            <LocalShippingIcon sx={{ marginRight: 2 }} fontSize="large" />
              Rastreo de envío
          </Typography>
      </div>
      <Box >
        {validGuide === false && (
          <Box
            noValidate
            component="form"
            sx={{ display: "flex" }}
          >
            <Grid container direction={"column"} spacing={2}>
              <Grid item>
                <Typography variant="h6">
                  Ingresa el número de guía de 17 caracteres
                </Typography>
              </Grid>

              <Grid item>
                <TextField
                  size="small"
                  fullWidth
                  id="noGuia"
                  label="No. de guía"
                  name="noGuia"
                  error={errors.noGuium}
                  onChange={(e) => {
                    setValue("noGuium", e.target.value);
                    setError(
                      "noGuium",
                      e.target.value.length <= 0 ||
                        e.target.value.length < 17 ||
                        e.target.value.length > 17
                    );
                    setMessage(
                      "noGuium",
                      e.target.value.length <= 0 ||
                        e.target.value.length < 17 ||
                        e.target.value.length > 17
                        ? ErrorMessages.envio.NoGuium
                        : ""
                    );
                  }}
                  onKeyDown={(ev) => {
                    if (ev.key === "Enter") {
                      ev.preventDefault();
                      getGuide(model.noGuium).then(
                        (response) => {
                          if (response) setValidGuide(response);
                        },
                        (err) => {
                          setError("noGuium", true);
                          setMessage(
                            "noGuium",
                            ErrorMessages.envio.GuiumNotFound
                          );
                        }
                      );
                    }
                  }}
                  helperText={messages.noGuium}
                  value={model?.noGuium || ""}
                />
              </Grid>

              <Grid item display={"flex"} justifyContent="center">
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ color: "#fff", marginRight: "10px" }}
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Cancelar
                </Button>

                <Button
                  disabled={disabled}
                  variant="contained"
                  onClick={() => {
                    getGuide(model.noGuium).then(
                      (response) => {
                        if (response) setValidGuide(response);
                      },
                      (err) => {
                        setError("noGuium", true);
                        setMessage(
                          "noGuium",
                          ErrorMessages.envio.GuiumNotFound
                        );
                      }
                    );
                  }}
                >
                  Buscar
                </Button>
              </Grid>
            </Grid>
          </Box>
        )}

        {validGuide === true && (
          <Box>
            <Grid container direction={"column"} spacing={1}>
              <Grid item>
                <Typography variant="h6">
                  Detalles del envío #{entity?.numeroGuia}
                </Typography>
              </Grid>

              <Grid item>
                <InfoGeneralEnvios tipo={1} />
              </Grid>

              <Grid item>
                <GuiasRastreo />
              </Grid>

              <Grid item>
                <ActualizacionesTracker tipo={"envios"} />
              </Grid>

              <Grid item display={"flex"} justifyContent="center">
                <Button
                  variant="contained"
                  onClick={() => {
                    setValidGuide(false);
                    setValue("noGuium", '');
                    setDisabled(true);
                  }}>
                  Cerrar
                </Button>
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default observer(RastreoEnvio);
